import styled from 'styled-components'

export const InputAndSuggestion = styled.div`
  position: relative;
  width: 100%;
`
